export const shadow_100 = `0px 4px 31px rgba(26, 33, 44, 0.04), 0px 0.751293px 3.88168px rgba(26, 33, 44, 0.03)`;
export const shadow_200 = `0px 4px 31px rgba(26, 33, 44, 0.06), 0px 0.751293px 8px rgba(26, 33, 44, 0.04)`;
